import get from 'lodash.get';
import SV from 'server-vars';
import Cookies from 'js-cookie';
import widgetLoader from 'dibs-widget-loader';
import { localStorage } from 'dibs-browser-storage';
import { getBuyerId, isMasquerading, cookieJarConstants } from 'dibs-cookie-jar';
import { isEmailOnlyMakeOffer } from './checkoutRedirects';
import { isGuestCheckoutV2Active } from './guestCheckoutAbTestHelpers';
import { TRADE } from 'dibs-buyer-layout/exports/userTypeEnums';
import { disableBeforeUnload } from '../shared/hooks/useBeforeUnload';

Cookies.defaults = {
    domain: SV.get('cookieDomain'),
    path: '/',
};

export function hasAnyTradeStatus() {
    return SV.get('userType') === TRADE;
}

export function getUserEmail() {
    return localStorage.getItem(cookieJarConstants.USER_EMAIL) || '';
}

export function logoutUser({ shouldReload = true, shouldRemoveEmail = true } = {}) {
    if (shouldRemoveEmail) {
        localStorage.deleteItem(cookieJarConstants.USER_EMAIL);
        Cookies.remove(cookieJarConstants.USER_EMAIL);
    }

    if (isMasquerading(document.cookie)) {
        localStorage.deleteItem(cookieJarConstants.MASQUERADE_BUYER);
        Cookies.remove(cookieJarConstants.MASQUERADE_BUYER);
    } else {
        localStorage.deleteItem(cookieJarConstants.USER);
        localStorage.deleteItem(cookieJarConstants.USER_LEGACY);
        localStorage.deleteItem(cookieJarConstants.USER_TYPE);
        Cookies.remove(cookieJarConstants.USER);
        Cookies.remove(cookieJarConstants.USER_EMAIL_TOKEN);
    }
    if (shouldReload) {
        disableBeforeUnload();
        location.reload();
    }
}

export function isLoggedIn() {
    return !!getBuyerId(document.cookie);
}

export function isUserCurrent(buyerId = null) {
    return Number(buyerId) === Number(getBuyerId(document.cookie));
}

export function isUserLoginRequired() {
    // auth when user logged out but email stored locally, or logged in with email session
    // but not when we just created their account from the make offer modal
    return (
        !isEmailOnlyMakeOffer() && !isLoggedIn() && !!getUserEmail() && !isGuestCheckoutV2Active()
    );
}

export function getSocialNetworkParameter({ socialNetworks, socialNetworkName, parameter }) {
    const network = (socialNetworks || []).find(
        n => get(n, 'socialNetwork.name') === socialNetworkName
    );
    return get(network, parameter);
}

export function isSocialNetworkConnected({ socialNetworks, socialNetworkName }) {
    const socialNetworkParameter = getSocialNetworkParameter({
        socialNetworks,
        socialNetworkName,
        parameter: 'status',
    });
    return socialNetworkParameter === 'CONNECTED';
}

export function checkFacebookStatus({ socialNetworks, openModal, relayEnvironment }) {
    widgetLoader
        .load('facebook', { relayEnvironment })
        .then(() =>
            global.FB.getLoginStatus(({ status, authResponse }) => {
                const userSocialId = getSocialNetworkParameter({
                    socialNetworks,
                    socialNetworkName: 'FACEBOOK',
                    parameter: 'socialId',
                });
                if (status !== 'connected' || authResponse.userID !== userSocialId) {
                    openModal();
                }
            })
        )
        .catch(openModal);
}

export function checkGoogleStatus({ socialNetworks, openModal, relayEnvironment }) {
    widgetLoader
        .load('google', { relayEnvironment })
        .then(() => {
            const userSocialId = getSocialNetworkParameter({
                socialNetworks,
                socialNetworkName: 'GOOGLE',
                parameter: 'socialId',
            });
            const GoogleAuth = window.gapi.auth2.getAuthInstance();
            const GoogleUser = GoogleAuth.currentUser.get();
            const id = GoogleUser.getId();
            if (!id || id !== userSocialId) {
                openModal();
            }
        })
        .catch(openModal);
}

/*
 * Hash function takes user email's local-part and encodes to base64.
 */
export function getAuthHash({ email }) {
    return btoa(email.split('@')[0]);
}
